import * as React from 'react';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Badge,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  Construction as ConstructionIcon,
  CalendarToday as CalendarTodayIcon,
  AccessTime as AccessTimeIcon,
  Description as DescriptionIcon,
  Today as TodayIcon,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import * as workTasksAPI from '../../services/workTasksAPI';

const linkStyle = {
  textDecoration: 'none',
  color: 'inherit',
};

// Work Tasks Navigation Item with Badge
const WorkTasksNavItem: React.FC = () => {
  const [newTasksCount, setNewTasksCount] = React.useState(0);

  React.useEffect(() => {
    const fetchNewTasksCount = async () => {
      try {
        const data = await workTasksAPI.getNewTasksCount();
        setNewTasksCount(data.count);
      } catch (error) {
        console.error('Error fetching new tasks count:', error);
      }
    };

    fetchNewTasksCount();
    
    // Refresh count every 30 seconds
    const interval = setInterval(fetchNewTasksCount, 30000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <Link to="/work-tasks" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <Badge badgeContent={newTasksCount} color="error" invisible={newTasksCount === 0}>
            <AssignmentIcon />
          </Badge>
        </ListItemIcon>
        <ListItemText primary="Arbeitsaufträge" />
      </ListItemButton>
    </Link>
  );
};

export const MainListItems = (
  <React.Fragment>
    <Link to="/dashboard" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
    </Link>
    <Link to="/projects" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Projekte" />
      </ListItemButton>
    </Link>
    <Link to="/regie-reports" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <DescriptionIcon />
        </ListItemIcon>
        <ListItemText primary="Regieberichte" />
      </ListItemButton>
    </Link>
    <Link to="/tagesberichte" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <TodayIcon />
        </ListItemIcon>
        <ListItemText primary="Tagesberichte" />
      </ListItemButton>
    </Link>
    <Link to="/time-tracking" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <AccessTimeIcon />
        </ListItemIcon>
        <ListItemText primary="Zeiterfassung" />
      </ListItemButton>
    </Link>
    <Link to="/sekuranten" style={linkStyle}>
      <ListItemButton>
        <ListItemIcon>
          <ConstructionIcon />
        </ListItemIcon>
        <ListItemText primary="Sekuranten" />
      </ListItemButton>
    </Link>
    <WorkTasksNavItem />
  </React.Fragment>
);

export const SecondaryListItems: React.FC = () => {
  const { user } = useAuth();
  
  // Nur Admins können die Benutzerverwaltung sehen
  const isAdmin = user?.role === 'admin';
  
  return (
    <React.Fragment>
      <ListSubheader component="div" inset>
        Verwaltung
      </ListSubheader>
      {isAdmin && (
        <Link to="/user-management" style={linkStyle}>
          <ListItemButton>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary="Benutzer" />
          </ListItemButton>
        </Link>
      )}
      <Link to="/project-calendar" style={linkStyle}>
        <ListItemButton>
          <ListItemIcon>
            <CalendarTodayIcon />
          </ListItemIcon>
          <ListItemText primary="Kalender" />
        </ListItemButton>
      </Link>
    </React.Fragment>
  );
}; 